<template>
  <div class="payments-list reset-indent">
    <div v-if="loading">
      <list-item loading v-for="(item, index) in 10" :key="index"></list-item>
    </div>
    <div v-else>
      <RecycleScroller
        :items="groupedPayments"
        :buffer="1000"
        key-field="listId"
        page-mode
        v-slot="{ item }"
      >
        <v-modal
          :full="!screen.breakPoint.tabPort"
          :fit-content="!screen.breakPoint.tabPort"
          :max-body-height="screen.breakPoint.tabPort ? '70vh' : null"
          :position="!screen.breakPoint.tabPort ? 'bottom': 'top'"
          animation="slide-up"
          block-scroll
          theme="light-grey"
          handle-click-bg
          class="payments-list__modal"
        >
          <template v-slot:activator="{ on }">
            <list-item two-columns @click="on()">
              <template v-slot:groupTitle>
                <div v-if="item.groupDate">
                  {{ item.groupDate }}
                </div>
              </template>

              <template v-slot:firstColumn>
                <list-item-group>
                  <list-item-content>
                    <list-item-title :cut-to-length="35">
                      {{ documentTypes[item.documentType] }}
                    </list-item-title>

                    <list-item-subtitle>
                      <span :class="item.operationType === 0 ? '' : 'text-color-success'">{{ operationTypes[item.operationType] }}</span>
                    </list-item-subtitle>
                  </list-item-content>
                </list-item-group>
              </template>

              <template v-slot:secondColumn>
                <list-item-title font-medium>
                  <span :class="item.operationType === 0 ? '' : 'text-color-success'">
                    <!-- TODO:Create Enum with normal operation type -->
                    {{ item.operationType === 0 && item.amount !== 0 ? '-' : '+' }}{{ toCurrency(item.amount, item.currency) }}
                  </span>
                </list-item-title>
              </template>
            </list-item>
          </template>

          <template v-slot:header>
            {{$t('components.PaymentsList.operationDocuments')}}
          </template>

          <div class="d-flex align-center justify-center payments-list__modal-content" v-if="item.url">
            <a class="payments-list__modal-download px-2 pb-2 text--center" href="#" @click.prevent="downloadDocument(item.url)">
              <span class="icon-srw payments-list__modal-download-icon"></span>
              <br>
              <span class="label text-color-grey">{{$t('components.PaymentsList.downloadDocuments')}}</span>
            </a>
          </div>

          <div class="d-flex align-center justify-center payments-list__modal-content" v-else>
            <div class="text--center pa-2">
              <span class="label text-color-grey" v-html="$t('components.PaymentsList.noDocuments')"></span>
            </div>
          </div>
        </v-modal>
      </RecycleScroller>
    </div>
  </div>
</template>

<script>
import ListItem from '@/ui/slots/List/ListItem'
import ListItemGroup from '@/ui/slots/List/ListItemGroup'
import ListItemTitle from '@/ui/slots/List/ListItemTitle'
import ListItemContent from '@/ui/slots/List/ListItemContent'
import ListItemSubtitle from '@/ui/slots/List/ListItemSubtitle'

import vModal from '@/ui/modals/vModal'

import groupByDate from '@/mixins/groupByDate'
import toCurrency from '@/mixins/toCurrency'
import screen from '@/mixins/screen'

export default {
  components: {
    ListItem,
    ListItemGroup,
    ListItemContent,
    ListItemTitle,
    ListItemSubtitle,

    vModal
  },

  mixins: [groupByDate, toCurrency, screen],

  props: {
    loadingItems: {
      type: Number,
      default: 10
    },
    dateField: {
      type: String,
      default: 'date'
    },
    payments: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    groupedPayments () {
      return this.groupByDate(this.payments, this.dateField)
    },

    documentTypes () {
      return {
        order: this.$i18n.t('components.BillList.documentTypes.order'),
        invoice: this.$i18n.t('components.BillList.documentTypes.invoice'),
        payment: this.$i18n.t('components.BillList.documentTypes.payment'),
        goldshop: this.$i18n.t('components.BillList.documentTypes.goldshop'),
        other: this.$i18n.t('components.BillList.documentTypes.other')
      }
    },

    operationTypes () {
      return [this.$i18n.t('components.PaymentsList.status.writeDowns'), this.$i18n.t('components.PaymentsList.status.replenishment')]
    }
  },

  methods: {
    downloadDocument (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang="scss">
  .payments-list {
    &__group {
      &:not(:last-child) {
        margin-bottom: 2rem;
      }
    }

    &__modal-download {
      display: block;
      border-radius: $border-radius-large;
      border: 1px $color-space-light solid;

      &-icon {
        color: $color-space;
        font-size: 10rem;
      }
    }
  }
</style>
